import React, { useEffect, useState } from "react";
import { DPDatePicker } from "Components/DP";
import pretty from "Shared/pretty";

export interface DateRange {
  start: Date | null;
  end: Date | null;
}

export interface DateRangePickerProps {
  selectedRange: DateRange;
  onDateRangeChange: (range: DateRange) => void;
  minDate: Date | null;
  maxDate: Date | null;
}

export const DateRangePicker = ({
  selectedRange,
  onDateRangeChange,
  minDate,
  maxDate,
}: DateRangePickerProps) => {
  const [inputValue, setInputValue] = useState<string>("");
  const [range, setRange] = useState<DateRange>(selectedRange);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onDatePickerValueChange = (dates: any) => {
    const [start, end] = dates;
    const newRange: DateRange = {
      start,
      end,
    };

    setRange(newRange);
    if (!start === !end) {
      onDateRangeChange(newRange);
    }
  };

  const getDateRangeformattedString = (range: DateRange) => {
    let newInputValue = "";
    if (range.start) {
      newInputValue += pretty.date(range.start.toISOString());
      newInputValue += " - ";
      if (range.end) {
        newInputValue += pretty.date(range.end.toISOString());
      }
    }
    return newInputValue;
  };

  useEffect(() => {
    const newInputValue = getDateRangeformattedString(range);
    setInputValue(newInputValue);
  }, [range]);

  return (
    <DPDatePicker
      value={inputValue}
      onChange={onDatePickerValueChange}
      startDate={range.start}
      endDate={range.end}
      selectsRange
      onDatePickerValueClear={() => { onDatePickerValueChange([]);}}
      shouldCloseOnSelect={false}
      maxDate={maxDate}
      minDate={minDate}
      textFieldProps={{
        label: "Submitted Date"
      }}
    />
  );
};
